import { Lab } from "pwapi";

import { PWAction } from "utils/redux";

import { LABS_LIST_SUCCESS } from "../actions/constants";

export type ListLabsState = {
  results: Lab[];
  count: number;
};

const reducer = (state: ListLabsState | null = null, action: PWAction) => {
  switch (action.type) {
    case LABS_LIST_SUCCESS:
      return action.payload.response;
    default:
      return state;
  }
};

export default reducer;
